const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "special":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "special",
    reducer: reducer,
};

export default data;